import { BaseApi, request } from "../utils/request";

// 游戏配置响应类型
export interface GameConfigResponse {
  showGuide: boolean;
  favor: boolean;
  disableEmbed: boolean;
  favorCount: number;
  onlineUser: number;
  supportDemo: boolean;
  hideHomeButton?: boolean;
  game: {
    id: string;
    name: string;
    icon: string;
    link: string;
    maintain: boolean;
    categoryId: string;
    platformId: string;
    self: boolean;
    title: string;
    rtp: number;
  };
  platform: {
    id: string;
    name: string;
    supportDemo: boolean;
    maintain: boolean;
    currencyIds: string[];
  };
  directlyPlay: boolean;
}

// 游戏API类
class GameApi extends BaseApi {
  constructor() {
    super();
  }
  /**
   * 获取游戏配置信息
   * @param gameId 游戏ID
   */
  async getGameConfig(gameId: string): Promise<GameConfigResponse> {
    const response = await this.post<GameConfigResponse, true>(
      "/api/game/game_config",
      {
        id: gameId,
      }
    );
    return response.data.model;
  }

  /**
   * 开始游戏
   * @param gameId 游戏ID
   * @param isDemo 是否为演示模式
   */
  async playGame(gameId: string, isDemo: boolean = false) {
    const api = isDemo
      ? "/api/game/play?demo=true&gameId="
      : "/api/game/play?gameId=";
    return api + gameId;
  }

  /**
   * 收藏/取消收藏游戏
   * @param gameId 游戏ID
   * @param favor 是否收藏
   */
  async toggleFavorite(gameId: string, favor: boolean) {
    return request("/api/game/add_game_favor", {
      gameId,
      favor,
    });
  }

  /**
   * 搜索游戏
   * @param search 搜索关键词
   * @param pageNo 页码
   * @param pageSize 每页大小
   * @param enabled 是否启用
   */
  async searchGames(params: {
    search: string;
    pageNo: number;
    pageSize: number;
    enabled?: boolean;
  }) {
    return this.post("/api/game/page", {
      query: {
        enabled: params.enabled !== undefined ? params.enabled : true,
        search: params.search,
        pageNo: params.pageNo,
        pageSize: params.pageSize,
      },
    });
  }
}

export const gameApi = new GameApi();
export default gameApi;
